import { CommonModule } from '@angular/common';
import { Component, NgModule, OnInit, ViewChild } from '@angular/core';
import { FormBuilder, FormGroup, FormsModule, ReactiveFormsModule, Validators } from '@angular/forms';
import { MatIconModule } from '@angular/material/icon';
import { ConfiguracoesService } from '../services/configuracoes.service';
import { AlertComponent } from "../../../alert/alert.component";
import { LoadingModalComponent } from "../../../loading-modal/loading-modal.component";




@Component({
  selector: 'app-configuracoes',
  standalone: true,
  imports: [ReactiveFormsModule, CommonModule, FormsModule, MatIconModule, AlertComponent, LoadingModalComponent],
  templateUrl: './configuracoes.component.html',
  styleUrls: ['./configuracoes.component.scss'],
  providers: [ConfiguracoesService]
})
export class ConfiguracoesComponent implements OnInit {

  @ViewChild(AlertComponent) alertComponent!: AlertComponent;
  @ViewChild(LoadingModalComponent) loadingComponent!: LoadingModalComponent;

  public inputCPFCNPJ: string = '';
  public dataQueuesUser: any;
  
  //Variaveis modal criar uma fila
  public isModalNewQueue: boolean = false;
  public rangeMinFire: number = 3;
  public rangeMaxFire: number = 6;
  public typeQueue: string = 'NORMAL';
  public formQueue!: FormGroup;

  //Variaveis modal delete
  public isModalDelete: boolean = false;
  public idChannelClientDelete!: number | undefined;

  constructor(private configService: ConfiguracoesService, private fb: FormBuilder) { }

  ngOnInit() { }

  public getListChannels(documentClient: string) {
    this.configService.getChannelsConfigured(documentClient.replace(/\D/g, "")).subscribe((response: any) => {
      this.dataQueuesUser = response;
    })
  }

  public handleMaskInput() {
    const numericValue = this.inputCPFCNPJ.replace(/\D/g, "");
    if (numericValue.length <= 11) {
      this.inputCPFCNPJ = numericValue.replace(/(\d{3})(\d{3})(\d{3})(\d{2})/, "$1.$2.$3-$4");
    } else {
      this.inputCPFCNPJ = numericValue.replace(/(\d{2})(\d{3})(\d{3})(\d{4})(\d{2})/, "$1.$2.$3/$4-$5");
    }
  }

  public handleSubmit() {
    this.getListChannels(this.inputCPFCNPJ);
  }

  public handleDeleteChannel(idFila: number) {
    this.idChannelClientDelete = idFila;
    this.isModalDelete = true;
  }

  public confirmHandleDeleteChannel() {
    if (this.idChannelClientDelete) {
      this.loadingComponent.activeLoading();
      this.configService.deleteChannelsConfigured(this.idChannelClientDelete).subscribe((response: any) => {
        this.getListChannels(this.inputCPFCNPJ);
        this.alertComponent.showAlert("Canal deletado com sucesso!");
        this.loadingComponent.inactiveLoading();
        this.handleCancelDeleteChannel();
      }, (error: any) => {
        this.alertComponent.showAlert(`Erro ao tentar deletar canal`);
        this.loadingComponent.inactiveLoading();
        this.handleCancelDeleteChannel();
      })
    }

  }

  public handleCancelDeleteChannel() {
    this.idChannelClientDelete = undefined;
    this.isModalDelete = false;
  }

  public handleOpenModalNewQueue(){
    this.formQueue = this.fb.group({
      idcliente: [this.dataQueuesUser.configuracoes.idcliente],
      nomefila: ['',[Validators.required]],
      queueId: ['',[Validators.required]],
      apiKey: ['', [Validators.required]],
      type: ['NORMAL',[Validators.required]],
      fire: [this.rangeMinFire,[Validators.required]]
    })
    this.isModalNewQueue = true;
  }

  public handleCloseModalNewQueue(){
    this.isModalNewQueue = false;
  }

  public handleSubmitForm(){
    this.loadingComponent.activeLoading();
    this.configService.setChannelClient(this.formQueue.value).subscribe((response: any)=> {
      this.getListChannels(this.inputCPFCNPJ);
      this.loadingComponent.inactiveLoading();
      this.alertComponent.showAlert('Canal cadastrado com sucesso!');
      this.handleCloseModalNewQueue();
    },(error: any)=> {
      this.loadingComponent.inactiveLoading();
      this.alertComponent.showAlert(`Erro a cadastrar canal: ${error.error.status}`,"error");
    })
  }

  public handleChangeTypeQueue(){
    switch(this.formQueue.value.type){
      case 'NORMAL':
      this.formQueue.get('fire')?.setValue(3)
      this.rangeMaxFire = 6;
      break;

      case 'APIOFICIAL': this.rangeMinFire = 3;
      this.rangeMaxFire = 200;
      break;

      default: console.log("Nenhuma opcao de canal valida");
      break;
    }
  }

}
